import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from "react-router-dom";
import './ActiveList.css?v=1.0';
import { getProgramDetails,ServiceResendSMS } from "../Services/Service";
import 'jquery/dist/jquery.min.js';
// import "datatables.net-dt/js/dataTables.dataTables"
// import "datatables.net-dt/css/jquery.dataTables.min.css" 
import Table from './DataTable/DataTable';
import { CustomLoader, decruptCipher } from "../Services/CommonLibrary"
import { Modal, Button } from "react-bootstrap";
import { color } from 'highcharts';
import { dateFormat } from 'highcharts';
import moment from 'moment';

const queryParams = new URLSearchParams(window.location.search);
const status = queryParams.get('status');

function ProgramDetail() {

    const clickhandler = name => console.log("delete", name);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [showSms, setShowSms] = useState(false);
    const handleClose = () =>setShowModal(false);
    const handleShow = () => setShowModal(true);
    const [hiddenValue, setHiddenValue] = useState('');
    const [showColumn, setShowColumn] = useState(true);

    const [serviceData, setServiceData] = useState([]);
    var storage= JSON.parse(localStorage.getItem('programDetail')) ? JSON.parse(localStorage.getItem('programDetail')) : 0;
    let programId = storage.programId;

    var company= localStorage.getItem('company') ? localStorage.getItem('company') : 0;
    const companyId = decruptCipher(company);

    
    
    const nav = useNavigate();
    let accessFrom= localStorage.getItem('access');
    let limit ='';
    const greenIcon = "https://appcdn.goqii.com/storeimg/79066_1678703854.png";
    const redIcon = "https://appcdn.goqii.com/storeimg/93309_1678704232.png";

    useEffect(() => {
        if(companyId == 2){
            setShowColumn(false);
        }

        fetchProgramDetails('all', 1, limit, programId);
    }, []);

    const fetchProgramDetails = async (filterEvent, currentPage, limit, programId) => {
        // if (accessFrom!='superadmin') {
        //     return nav('/upload');      
        //   }
        getProgramDetails(filterEvent, currentPage, limit, programId)
            .then((res) => {
                setServiceData(res.data.data);
                setLoading(false);
            });
    }

    const viewPopup=(encPatientId)=>{
        setShowSms(true);
        setHiddenValue(encPatientId);
        setShowModal(true)
    }

    const messageClick=()=>{
        
        ServiceResendSMS(hiddenValue)
            .then((res) => {
                setShowSms(false);
            }
        );
    }
    
   const emptyValue = <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>;
    const columns = [
        
        {id:1,name:<div className='tdData text-start'>&nbsp;</div>,selector: row=>row.userImageUrl,cell:row => <div className='tdData'><Link to={`/profile/${row.encPatientId}`}><img src={`${row.userImageUrl}`} className="user-profile-img" /></Link></div>,sortable: false},
        {id:2,name : <div className='tdData text-start'>Name</div>,  selector:row=>row.fullName, cell: row => <div className='tdData'><Link to={`/profile/${row.encPatientId}`}>{row.fullName}</Link></div>,sortable: true},
        {id:3,name : <div className='tdData text-start'>NHS ID</div>,selector: row => row.nhsNumber, cell: row => <div className='tdData'>{row.nhsNumber}</div>,sortable: true},
        {id:4,name : <div className='tdData text-start'>Email</div>,selector: row => row.email, cell: row => <div className='tdData'>{row.email}</div>,sortable: true},
        {id:5,name : <div className='tdData text-start'>Mobile</div>,selector: row => row.mobile, cell: row => <div className='tdData'>{row.mobile}</div>,sortable: true},
        showColumn ? {id:6,name : <div className='tdData text-start'>Division</div>,selector: row => row.division, cell: row => <div className='tdData'>{row.division}</div>,sortable: true,draw:8} : '',
        {id:7,name : <div className='tdData'>Practice</div>,selector: row => row.clinicName, cell: row => <div className='tdData'>{row.clinicName}</div>,sortable: true},
        showColumn ? {id:8,name : <div className='tdData text-start'>Lead Doctor</div>,selector: row => row.doctorName, cell: row => <div className='tdData'>{row.doctorName}</div>,sortable: true} : '',
        showColumn ? {
            id: 21,
            name: <div className='tdData text-start'>WhatsApp Sent</div>,
            selector: row => row.whatsappDateSent,
            cell: row => {
                var whatsappDateSent = row.whatsappDateSent !== '0000-00-00 00:00:00' ? moment(row.whatsappDateSent).format('DD MMM YYYY hh:mm A') : '';
                return (
                    <div className='tdData'>
                        <img style={{height: "12px"}} src={row.whatsappDateSent !== '0000-00-00 00:00:00' ? greenIcon : redIcon} /><br/>
                        {row.whatsappDateSent !== '0000-00-00 00:00:00' ? whatsappDateSent : emptyValue}
                    </div>
                );
            },
            sortable: true
        } : '',

        {id:22,name:  <div className='tdData text-start'>WhatsApp Delivery Status</div>,selector:row=>row.whatsappDeliveryDate, 
            cell: row => {
                var smsDeliverDateNewD = row.whatsappDeliveryDate !== '0000-00-00 00:00:00' ? moment(row.whatsappDeliveryDate).format('DD MMM YYYY hh:mm A') : '-';
                return (
                    <div className='tdData'>
                        <img style={{height: "12px"}} src={(row.whatsappStatus === 'Delivered' || row.whatsappStatus==='Read') ? greenIcon : redIcon} /><br/>
                        {row.whatsappDeliveryDate !== '0000-00-00 00:00:00' ? smsDeliverDateNewD : emptyValue}
                    </div>
                );
            },
            conditionalCellStyles: [
                {
                    when: row => (row.whatsappStatus ===  'Delivered' || row.whatsappStatus==='Read'),
                    style: {color: 'green'}, 
                },
                {
                    when: row => row.whatsappStatus ===  '',
                    style: {color: 'red'},
                },
            ],
            sortable: true
        },

        {
            id: 9,
            name: <div className='tdData text-start'>SMS Sent</div>,
            selector: row => row.smsSentDateNew,
            cell: row => {
                var dateNew = row.smsSentDateNew !== '-' ? moment(row.smsSentDateNew).format('DD MMM YYYY hh:mm A') : '';
                return (
                    <div className='tdData'>
                        <img style={{height: "12px"}} src={row.smsSentDateNew !== '-' ? greenIcon : redIcon} /><br/>
                        {row.smsSentDateNew !== '-' ? dateNew : emptyValue}
                    </div>
                );
            },
            sortable: true
        },
        {id:10,name:  <div className='tdData text-start'>Delivery Status</div>,selector:row=>row.smsDeliverDate, 
            cell: row => {
                var smsDeliverDateNew = row.smsDeliverDate !== '-'  && row.smsSentDateNew !== '-' ? moment(row.smsDeliverDate).format('DD MMM YYYY hh:mm A') : '-';
                return (
                    <div className='tdData'>
                        <img style={{height: "12px"}} src={row.smsStatus == 'DELIVERED' && row.smsSentDateNew !== '-' ? greenIcon : redIcon} /><br/>
                        {row.smsDeliverDate !== '-' && row.smsSentDateNew !== '-' ? smsDeliverDateNew : emptyValue}
                    </div>
                );
            },
            conditionalCellStyles: [
                {
                    when: row => row.smsStatus ==  'DELIVERED',
                    style: {color: 'green'}, 
                },
                {
                    when: row => row.smsStatus ==  'UNDELIVERED',
                    style: {color: 'red'},
                },
            ],
            sortable: true
        },

        
        {id:11,name : <div className='tdData text-start'>Login Date</div>,selector:row=>row.loginDate,
            cell: row => {
                var dateNew = row.loginDate !== '-' ? moment(row.loginDate).format('DD MMM YYYY hh:mm A') : '';
                return (
                    <div className='tdData'>
                        <img style={{height: "12px"}} src={row.loginDate !='-' ? greenIcon : redIcon} /><br/>
                        {row.loginDate != '-' ? dateNew : emptyValue}
                    </div>
                );
            },sortable: true
        },

        {id:12,name : <div className='tdData text-start'>Onboarding Date</div>,selector:row=>row.onboardedDate, 
            cell: row => {
                var dateNew = row.onboardedDate !== '-' ? moment(row.onboardedDate).format('DD MMM YYYY hh:mm A') : '';
                return (
                    <div className='tdData'>
                        <img style={{height: "12px"}} src={row.onboardedDate !='-' ? greenIcon : redIcon} /><br/>
                        {row.onboardedDate != '-' ? dateNew : emptyValue}
                    </div>
                );
            },sortable: true
        },
        {id:20,name : <div className='tdData text-start'>First consultation Date</div>,selector:row=>row.firstConsultationDate, 
            cell: row => {
                var dateNew = row.firstConsultationDate !== '-' ? moment(row.firstConsultationDate).format('DD MMM YYYY hh:mm A') : '';
                return (
                    <div className='tdData'>
                        <img style={{height: "12px"}} src={row.firstConsultationDate !='-' ? greenIcon : redIcon} /><br/>
                        {row.firstConsultationDate != '-' ? dateNew : emptyValue}
                    </div>
                );
            },sortable: true
        },
        {id:13,name : <div className='tdData text-start'>Coach Selected</div>,selector: row => row.caoachService, cell: row => <div className='tdData'>{row.caoachService}</div>,sortable: true},
        {id:14,name : <div className='tdData text-start'>Coach Feedback Rating</div>,selector: row => row.coachFeedBackRating, cell: row => <div className='tdData'>{row.coachFeedBackRating}</div>,sortable: true},
        {id:18,name : <div className='tdData text-start'>No. of calls</div>,selector: row => row.no_calls, cell: row => <div className='tdData'>{row.no_calls}</div>,sortable: true},
        {id:16,name : <div className='tdData text-start'>Latest call Date</div>,selector: row => row.latestcallscheduled, cell: row => <div className='tdData'>{row.latestcallscheduled}</div>,sortable: true},
        {id:17,name : <div className='tdData text-start'>Coaching End</div>,selector: row =>row.coachingEndDate, cell: row => <div className='tdData'>{row.coachingEndDate}</div>,sortable: true},
        
        {   id:15,
            name: "Send", //Consultation Notes
            button: true,
            omit: (accessFrom=='superadmin'  || accessFrom=='admin' ) ? false : true ,
            cell: row =>{
                 return row.status == 'Inactive' && (accessFrom=='superadmin' || accessFrom=='admin')  ? 
                    <button className='btn btn-secondary btn-sm btn-edit' style={{fontSize: '12px', paddingLeft: "12px", paddingRight: "12px"}} onClick={(e)=>viewPopup(row.encPatientIdWithType)}>{row.buttonName}</button>
                :null
                }
        },
        {   id:19,
            name: "Edit", //Consultation Notes
            button: true,
            omit: (accessFrom=='superadmin' || accessFrom=='admin') ? false : true ,
            cell: row =>{
                 return accessFrom=='superadmin' || accessFrom=='admin'  ? 
                 <Link to={`/patient-add/${row.encPatientId}`}><button className='btn btn-primary btn-sm btn-edit' style={{fontSize: '12px'}} >Edit</button></Link>
                :null
                }
        }
      ];    

    
    return (
        <section className='projects-section data-pd' style={{overflow:"inherit"}}>
             <div className='row'>
                <div className="FL">
                    <div className='table-responsive' style={{overflowX:"inherit"}} id='modalityLifestyle'>
                        <Table data={serviceData} column={columns} title={storage.programName} showFilter="true" click={clickhandler} exportCSV='true' filterStatus='true' filterPractice='true' filterDivision='true' filterSmsDate='true' showClearbtn="true" csvName='User List' />
                    </div>
                </div>
            </div>
            { loading ? <CustomLoader /> : null }

            {showModal?
                <>
                
                <Modal dialogClassName="modal-md" show={showModal} onHide={handleClose}>
                  <Modal.Header closeButton>
                    <Modal.Title>Send SMS</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    {showSms ? <h5>Are you sure? Want to send SMS!</h5> :
                        <h5 className='text-success'>SMS Send Successfully</h5>}
                    
                  </Modal.Body>
                  <Modal.Footer>
                  {showSms ?<Button variant="success" onClick={(e)=>messageClick()} className="btn-sm">
                      Ok
                    </Button>:null}
                    <Button variant="danger" onClick={handleClose} className="btn-sm">
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>
              </>
            :null
            }

        </section>
        

    );
}
export default ProgramDetail;